import script from "./ContributorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributorPage.vue?vue&type=script&setup=true&lang=js"

import "./ContributorPage.vue?vue&type=style&index=0&id=6499a579&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6499a579"]])

export default __exports__